module.exports = __webpack_public_path__ + "Poppins-ThinItalic.7d9075e1565215aa939a.woff2";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-ThinItalic.woff2
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-ThinItalic.woff2
// module chunks = styles